import { ColumnHeader } from '@models/Products';
import ProductsTableFirstActivityCell from '@components/top-selling-products/products-table-first-activity-cell/ProductsTableFirstActivityCell';
import * as styles from '@components/top-selling-products/ProductsTable.module.scss';
import { ProductsCompareRowHeaderName } from '@components/products-compare-modal/Types';
import ProductsCompareModalKpiCell from '../products-compare-modal-kpi-cell/ProductsCompareModalKpiCell';
import { random } from 'lodash';

interface Props {
  firstActivityRow: string[];
}

const ProductsCompareModalFirstActivityRow: React.FC<Props> = ({ firstActivityRow }) => {
  const generateFirstActivityRow = firstActivityRow.map((row) => ({
    id: random(0, 1000),
    value: row,
  }));
  return (
    <tr className={styles.ProductsTable__TableRow__WithHover}>
      <ProductsCompareModalKpiCell headerName={ProductsCompareRowHeaderName[ColumnHeader.firstActivity]} />
      {generateFirstActivityRow.map((row) => {
        return <ProductsTableFirstActivityCell key={row.id} firstActivityDate={row.value} cellAlignment={'right'} />;
      })}
    </tr>
  );
};

export default ProductsCompareModalFirstActivityRow;
